// namespace
export const INVITATIONS_NAMESPACE = 'invitations'

// getters
export const INVITATIONS_GETTER = 'invitations'

// mutations
export const INVITATIONS_MUTATION_ENTIRE_INVITATIONS = 'updateEntireInvitations'
export const INVITATIONS_MUTATION_SINGLE_INVITATION = 'updateSingleInvitation'

// actions
export const INVITATIONS_ACTION_GET_INVITATIONS = 'fetchInvitations'
export const INVITATIONS_ACTION_INVITE = 'inviteInvitation'
export const INVITATIONS_ACTION_ACCEPT = 'acceptInvitation'
export const INVITATIONS_ACTION_REJECT = 'rejectInvitation'
export const INVITATIONS_ACTION_CANCEL = 'cancelInvitation'



// WEBPACK FOOTER //
// ./src/store/modules/invitations-types.js